import { fbt } from 'fbtee'
import { pageTitle, useDocumentTitle } from '../../hooks/useDocumentTitle'
import { useAuth } from '../../hooks/useAuth'
import { PageLayout } from '../../components/PageLayout'
import { AccountSection } from './AccountSection'
import { PreferencesSection } from './PreferencesSection'
import { IntegrationsSection, NotificationsSection } from './IntegrationsSections'
import { PrivacySection } from './PrivacySection'
import { HelpSection } from './HelpSection'
import { AboutSection } from './AboutSection'

export default function SettingsPage() {
  useDocumentTitle(pageTitle(fbt('Settings', 'Browser tab title for the settings page')))
  const { user, signedInUid } = useAuth()
  const signedIn = !!signedInUid && !!user

  return (
    <PageLayout
      back="/profile"
      title={
        <p className="font-semibold text-sm leading-none">
          <fbt desc="Heading for the settings page">Settings</fbt>
        </p>
      }
    >
      {signedIn && <AccountSection user={user} />}
      <PreferencesSection />
      {signedIn && <NotificationsSection />}
      {signedIn && <IntegrationsSection />}
      <PrivacySection signedIn={signedIn} />
      <HelpSection signedIn={signedIn} hasUser={!!user} />
      <AboutSection />
    </PageLayout>
  )
}
